import { useEffect, useState } from "react";
const ModeController = () => {
  const [mode, setMode] = useState<string>("sun");
  const ParentEl = document.querySelector("html") as HTMLElement;

  useEffect(() => {
    if (ParentEl) ParentEl.classList.toggle("dark");
  }, []);
  const modeController = () => {
    if (mode === "sun") {
      setMode("dark");
    } else {
      setMode("sun");
    }
    ParentEl.classList.toggle("dark");
  };
  return (
    <button
      onClick={() => modeController()}
      className="transition-all text-blue lg:hover:text-lightGray flex justify-between items-center"
    >
      {mode !== "dark" ? (
        <svg
          width="20"
          height="20"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.81724 0.900391C3.1055 0.900391 0.899414 3.10691 0.899414 5.81865C0.899414 8.53039 3.1055 10.7369 5.81724 10.7369C8.52854 10.7369 10.7351 8.53083 10.7351 5.81865C10.7351 3.10648 8.52854 0.900391 5.81724 0.900391Z"
            fill="currentColor"
          />
        </svg>
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="transition-all text-inherit"
            d="M19.5016 11.3423C19.2971 11.2912 19.0927 11.3423 18.9137 11.4701C18.2492 12.0324 17.4824 12.4924 16.639 12.7991C15.8466 13.1059 14.9776 13.2592 14.0575 13.2592C11.9872 13.2592 10.0958 12.4158 8.74121 11.0611C7.38658 9.70649 6.54313 7.81512 6.54313 5.74483C6.54313 4.87582 6.69649 4.03237 6.95208 3.26559C7.23323 2.4477 7.64217 1.70649 8.17891 1.06751C8.40895 0.786362 8.35783 0.377416 8.07668 0.147384C7.89776 0.0195887 7.69329 -0.0315295 7.48882 0.0195887C5.31629 0.607448 3.42492 1.91096 2.07029 3.64898C0.766773 5.36144 0 7.48285 0 9.78317C0 12.5691 1.1246 15.0995 2.96486 16.9397C4.80511 18.78 7.3099 19.9046 10.1214 19.9046C12.4728 19.9046 14.6454 19.0867 16.3834 17.732C18.147 16.3519 19.4249 14.3838 19.9617 12.1346C20.0639 11.7768 19.8594 11.419 19.5016 11.3423Z"
            fill="currentColor"
          />
        </svg>
      )}
    </button>
  );
};

export default ModeController;
